type TranslateFn = (key: string, opts?: object) => string;

export const pluralizedUnitOptions = <T extends string>(
  units: readonly T[],
  labelKeyPrefix: string,
  count: number | null | undefined,
  t: TranslateFn,
): { label: string; value: T }[] =>
  units.map(unit => ({
    label: t(`${labelKeyPrefix}${unit}`, { count: count ?? 0 }),
    value: unit,
  }));
